<template>
  <div class="floating-buttons">
    <a href="#" class="floating-button" @click.prevent="scrollToTop" v-show="showTopButton">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 12L12 5L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
    
    <a href="#" class="floating-button" :aria-label="$t('nav.ticketCenter')" :title="$t('nav.ticketCenter')" @click.prevent="openTicketCenter">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'FloatingButtons',
  setup() {
    const router = useRouter()
    const showTopButton = ref(false)
    
    const handleScroll = () => {
      showTopButton.value = window.scrollY > 300
    }
    
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
    
    const openTicketCenter = () => {
      router.push('/tickets?create=true')
    }
    
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    
    return {
      showTopButton,
      scrollToTop,
      openTicketCenter
    }
  }
}
</script>

<style scoped>
.floating-buttons {
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 99;
}

.floating-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--card-background);
  color: var(--text-primary);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}

.floating-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #4461F2 0%, #38BFFF 100%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: -1;
}

.floating-button:hover {
  transform: translateY(-5px);
  color: white;
  border-color: transparent;
  box-shadow: 0 8px 16px rgba(68, 97, 242, 0.25);
}

.floating-button:hover:before {
  opacity: 1;
}

@media (max-width: 768px) {
  .floating-buttons {
    bottom: 20px;
    right: 20px;
  }
  
  .floating-button {
    width: 42px;
    height: 42px;
  }
}
</style>
